import {QueryClientProvider} from '@tanstack/react-query';
import {RouterProvider} from '@tanstack/react-router';
import {createRoot} from 'react-dom/client';
import {loadInterfaceModel,type SurfaceIdentity} from './model';
import {queryClient} from './query';
import {createApplicationRouter} from './router';

async function start(){
  const mount=document.querySelector<HTMLElement>('[data-tallyup-runtime]');
  if(!mount) throw new Error('TallyUp application mount is unavailable.');
  const surface=mount.dataset.surface as SurfaceIdentity;
  if(!['tenant','admin','developer-docs','internal-api-docs','enterprise'].includes(surface)) throw new Error('TallyUp surface is not selected by this realization.');
  const model=await loadInterfaceModel(mount.dataset.modelSrc||'');
  if(model.distribution.identity!==mount.dataset.distribution
    ||model.distribution.surface!==surface)throw new Error('Interface distribution selection does not match this realization.');
  const router=createApplicationRouter(model,surface,mount.dataset.authSrc||'');
  createRoot(mount).render(<QueryClientProvider client={queryClient}><RouterProvider router={router}/></QueryClientProvider>);
}

start().catch(error=>{
  const mount=document.querySelector<HTMLElement>('[data-tallyup-runtime]');
  if(mount){
    const message=document.createElement('p');
    message.textContent=error instanceof Error?error.message:'Application could not start.';
    const heading=document.createElement('h1');heading.textContent='Interface unavailable.';
    const unavailable=document.createElement('main');unavailable.className='protected-gate';unavailable.role='alert';
    unavailable.append(heading,message);mount.replaceChildren(unavailable);
  }
});
